import { FC } from 'react'
import { DistributionSecretDraft } from '../types/types'
import MintWindow from './MintWindow'

interface SecretDistributionProps {
  secret: DistributionSecretDraft
}

const SecretDistribution: FC<SecretDistributionProps> = ({ secret }) => {
  return (
    <div>
      <h4>Secret Distribution</h4>
      <MintWindow startDate={secret.startDate} endDate={secret.endDate} />
      {secret.name && (
        <p>
          <strong>Secret passphrase:</strong> {secret.name}
        </p>
      )}
    </div>
  )
}

export default SecretDistribution
